var app = angular.module('leonardo');

var RecurrenceService = function() {
  var service = {};

  service.getWeek = function(date) {
    var d = moment(date);
    if (d.date() <= 7) {
      return 'first';
    }
    if (d.date() <= 14) {
      return 'second';
    }
    if (d.date() <= 21) {
      return 'third';
    }
    return 'last';
  };

  service.getValue = function(mode, date) {
    var d = moment(date);
    switch (mode) {
      case 'monthly':
        return d.date(1).add(1, 'months').subtract(1, 'days').format('YYYY-MM-DD');
      case 'weekly':
        switch (service.getWeek(date)) {
          case 'first':
            return d.date(7).format('YYYY-MM-DD');
          case 'second':
            return d.date(14).format('YYYY-MM-DD');
          case 'third':
            return d.date(21).format('YYYY-MM-DD');
        }
        return moment(date).date(1).add(1, 'months').subtract(1, 'days').format('YYYY-MM-DD');
      default:
        return date;
    }
  };

  service.hasNext = function(mode, date) {
    return (service.getValue(mode, date) !== service.getValue(mode, moment().format('YYYY-MM-DD')));
  };

  service.next = function(mode, date) {
    var d = service.getValue(mode, date);
    return service.getValue(mode, moment(d).add(1, 'days').format('YYYY-MM-DD'));
  };

  service.prev = function(mode, date) {
    var d = moment(date);
    switch (mode) {
      case 'monthly':
        return d.date(1).subtract(1, 'days').format('YYYY-MM-DD');
      case 'weekly':
        switch (service.getWeek(date)) {
          case 'last':
            return d.date(21).format('YYYY-MM-DD');
          case 'third':
            return d.date(14).format('YYYY-MM-DD');
          case 'second':
            return d.date(7).format('YYYY-MM-DD');
        }
        return d.date(1).subtract(1, 'days').format('YYYY-MM-DD');
      default:
        return d.subtract(1, 'days').format('YYYY-MM-DD');
    }
  };

  service.getDateRanges = function(mode, date, status) {
    var start = null;
    var d = moment(date);
    var end = service.getValue(mode, date);
    switch (mode) {
      case 'daily':
      case 'document':
        if (status === 'incomplete') {
          start = d.date(1).format('YYYY-MM-DD');
          return [start, end];
        }
        else {
          return [date];
        }
      case 'monthly':
        if (status === 'incomplete') {
          start = d.subtract(1, 'months').date(1).format('YYYY-MM-DD');
          end = d.add(1, 'months').subtract(1, 'days').format('YYYY-MM-DD');
        }
        else {
          start = d.date(1).format('YYYY-MM-DD');
        }
        return [start, end];
      case 'weekly':
        if (status === 'incomplete') {
          start = d.date(1).format('YYYY-MM-DD');
        }
        else {
          switch (service.getWeek(date)) {
            case 'first':
              start = d.date(1).format('YYYY-MM-DD');
              break;
            case 'second':
              start = d.date(8).format('YYYY-MM-DD');
              break;
            case 'third':
              start = d.date(15).format('YYYY-MM-DD');
              break;
            case 'last':
              start = d.date(22).format('YYYY-MM-DD');
              break;
          }
        }
        return [start, end];
    }
  };

  return service;
};

app.factory('RecurrenceService', [RecurrenceService]);
